import gql from 'graphql-tag';

const auctionLocationQuery = gql`
  query apmsLocationList(
    $name: String
    $auctionLocationSearch: String
    $page: Int
    $size: Int
    $active: Boolean
    $isPaginationActive: Boolean
  ) {
    apmsLocationList(
      name: $name
      search: $auctionLocationSearch
      size: $size
      page: $page
      active: $active
      isPaginationActive: $isPaginationActive
    ) {
      acceptsReturns
      accountingEmail
      additionalEmails
      auctionNotes
      auctionOs
      auctionSystem
      auctionedgeCode
      bscLocation
      createdAt
      dealerNumber
      dsEndDate
      dsPaidPsiEnabled
      dsPsiEndDate
      dsPsiStartDate
      dsStartDate
      externalAuctionEmails
      locationId
      inspectionsEnabled
      launchDate
      locationArea
      locationCity
      locationCode
      locationName
      locationState
      locationStreet
      locationZip
      macolaInventoryCode
      partnerChannelId
      partnerNetwork
      psiEndDate
      psiStartDate
      purchaseEnabled
      returnEmails
      returnInstructions
      saleDays
      supplierNumber
      titleAllowanceDays
      updatedAt
      xcira
      ineligibleLanes {
        id
        ineligibleCode
        ineligibleId
        laneEndDate
        laneNumber
        laneStartDate
      }
    }
  }
`;

export default auctionLocationQuery;
